import React, {useEffect, useState} from "react";
import "./SendInfoInvoice.scss";
import {useHistory, useLocation} from "react-router-dom";
import {GetBasket, StoreOnlineAddress} from "../../Components/OnlineAddress/OnlineAddressService";
import {StoreOnlineCoupons, StoreOnlineSendInfo, StoreOnlineSetSendInfo} from "./SendInfoService";
import toaster from "toasted-notes";
import {OnlineAddress} from "../../Components";
import Shipping from "../../Components/Shipping/Shipping";
import {Drawer, Modal} from "antd";
import ReactPlayer from "react-player";
import { CheckCircleOutlined } from '@ant-design/icons';
import moment from "moment-jalaali";
import {Address} from "..";
import {createInvoiceFromOrder, updateOrderAddressTime} from "../../Services/apis";
import {StoreOnlineCreateInvoice} from "../Payment/PaymentService";

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function SendInfoInvoice() {

    const history = useHistory();

    const [defaultAddress,set_defaultAddress] = useState({});
    const [times,set_times] = useState([]);
    const [radio,set_radio] = useState("");
    const [desc,set_desc] = useState("");
    const [merchant,set_merchant] = useState({});
    const [mParamId,set_mParamId] = useState(null);
    const [order,set_order] = useState({});

    const location = useLocation()

    useEffect(()=>{
        if(location.state){
            console.log("Order : ",location.state)
            if(location.state.order)
                set_order(location.state.order)

            if(location.state.merchantParamId)
                set_mParamId(location.state.merchantParamId)
        }

        let m = location.state && location.state.merchantParamId ? location.state.merchantParamId :"DY86rrgWwc";
        getSendTime(m)
    },[])



    const getSendTime = async (merchantId) =>{
        const response = await StoreOnlineSendInfo(merchantId,1);
        console.log("times : ",response);
        set_times(response.data.results);
        let find = response.data.results.find(item=>item.is_default);
        set_radio(find.uid)
    }




    //drugstore mock flow -------------------------------------------------------
    const [bookModal,set_bookModal] = useState(false)
    const handleOk = () => {
        set_bookModal(false);
    };

    const handleCancel = () => {
        set_bookModal(false);
    };


    const redirectToGateWayPage = async (invoice) => {
        console.log(":))))",invoice)
        try {
            //create invoice
            let req = {
                amount: invoice.invoice.payable_amount,
                client_callback: window.location.origin+"/online-order-detail/"+invoice.invoice.uid,
                res_num: invoice.invoice.uid,
                acceptor: invoice.invoice.merchant.acceptor
            }
            console.log(":$$$))))",req)
            const response = await StoreOnlineCreateInvoice(req);
            history.push("/online-store-gateway", {create: response.data})
        } catch (e) {
            console.log(e)
            return
        }
    }


    const validate =  async () =>{
        if(address.address){
            try {
                let obj = {
                    address: address.uid,
                    shipping_time_interval: radio
                }

                console.log(obj)
                const res = await updateOrderAddressTime(order.uid,obj)
                const invoice = await createInvoiceFromOrder(order.uid)
                console.log(res)
                console.log(invoice)
                redirectToGateWayPage(invoice.data)

            }catch (e) {
                toaster.notify(({ onClose }) => (<Error   message={"مشکل در درخواست"}/>),{duration: 2000});
            }
        }else {
            toaster.notify(({ onClose }) => (<Error   message={"آدرس را کامل نمایید"}/>),{duration: 2000});
        }
    }




    const [shipTime,set_shipTime] = useState("")
    const [shipDate,set_shipDate] = useState(moment(new Date()).format("jYYYY/jMM/jDD"))
    const [visible,setVisible] = useState(false)
    const [address,set_address] = useState({})

    const showDrawer = () => {
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
    };



    const side = (val,addressData) => {
        console.log(val)
        console.log("val :",val)
        console.log("address dat : ",addressData)
        set_address(addressData)
        setVisible(false);

    };

    const changeTime = async (id) =>{
        // const response = await StoreOnlineSetSendInfo(id);
    }

    return(
        <>
            <Modal visible={bookModal}  footer={null} closable={false}  onOk={handleOk} >
                <div className="booking-modal">
                    <CheckCircleOutlined style={{fontSize:46,color:"#9adb9a"}} />
                    <br/>
                    <span className="booking-modal-message">{` درتاریخ ${shipDate} از ساعت ${shipTime.from+" تا "+shipTime.to} کارشناس برای گرفتن نمونه به محل شما مراجعه می نماید`}</span>
                    <span className="booking-modal-hint">لطفا در تاریخ و ساعت ذکر شده در محل حضور داشته باشید</span>
                    <span className="booking-modal-text" onClick={()=>{
                        history.push("/reward")
                    }}>تایید و پرداخت</span>
                </div>
            </Modal>
            <div className="basket-brand">
                <img src={merchant.thumbnail} alt=""/>
            </div>

            <div className="online-sendinfo-container">
                <div className="sinfo-wr" style={{margin:"0 16px"}}>

                    <Drawer  width={350}
                             placement="right" onClose={onClose} visible={visible}>>
                        <Address side={side} back={false}/>
                    </Drawer>

                    <div className="online-header-section">
                        <i className="fa fa-arrow-left"
                           onClick={()=>{
                               history.goBack()
                           }}
                        ></i>
                        <span>ارسال اطلاعات</span>
                    </div>


                    <div className="address-section">
                        <div className="address-invoice-header">
                            <span className="address-define" onClick={()=>{showDrawer()}}>{address.address?"تغییر آدرس":" تعیین آدرس"}</span>
                            <span className="title">آدرس تحویل سفارش</span>
                        </div>
                        <p>{address?.address}</p>
                    </div>

                    <div className="address-section">
                        <span className="title">توضیحات سفارش</span>
                        <textarea
                            value={desc}
                            onChange={(e)=>{
                                set_desc(e.target.value)
                            }}  rows="4" cols="50" >
                </textarea>
                    </div>



                    {/*<span className="title">زمان ارسال</span>*/}

                    <Shipping selDate={set_shipDate} selTime={set_shipTime}/>

                    {/*<div className="in-person-sec">*/}
                    {/*    <span>مراجعه حضوری</span>*/}
                    {/*    <input type="checkbox" name="" id=""/>*/}
                    {/*</div>*/}

                    <div className="send-time-section" style={{visibility:"hidden"}}>
                        <span className="title">زمان ارسال</span>


                        <div className="send-time-list">
                            {times.map(item=>{
                                return(
                                    <div className="send-time-item">
                                        <span>{item.title}</span>
                                        <input onClick={()=>{
                                            set_radio(item.uid);
                                            changeTime(item.uid)
                                        }}
                                               type="radio" name="send" id="" value={item.uid} checked={radio===item.uid}/>
                                    </div>
                                )
                            })}
                        </div>
                    </div>


                    <div className="online-product-footer">
                        <div className="notAdded-mode">
                            <div className="add-to-basket-btn" onClick={()=>{
                                    validate();

                            }}>
                                <span>ادامه</span>
                                {/*<span>رزرو</span>*/}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="online-product-footer-md">
                <div className="notAdded-mode-md">
                    <div className="add-to-basket-btn" onClick={()=>{
                        validate();
                    }}>
                        <span>ادامه فرایند خرید</span>
                    </div>
                    <div className="add-to-basket-btn" onClick={()=>{
                        history.goBack()
                    }}>
                        <span>برگشت</span>
                    </div>
                </div>
            </div>
            </>
    )
}

export {SendInfoInvoice};
